import { useQuery } from "@apollo/client";
import gqlHeader from "@assets/gql/header.gql";
import React from "react";
import { Template } from "@assets/spa/template";
import { useLayoutContext } from "@assets/spa/context/layout";
import { useLang } from "@ambiguous/useLang";
import './header.scss';
export function Header() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [layout, setLayout] = useLayoutContext();
    const [language] = useLang();
    const { data, loading } = useQuery(gqlHeader, {
        variables: {
            id: layout === null || layout === void 0 ? void 0 : layout.headerId,
            language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
        },
        skip: !(layout === null || layout === void 0 ? void 0 : layout.headerId),
    });
    const sections = (_a = data === null || data === void 0 ? void 0 : data.header) === null || _a === void 0 ? void 0 : _a.elementorData;
    const sectionData = {
        sections: sections ? JSON.parse(sections || '[]') : undefined,
        postId: (_b = data === null || data === void 0 ? void 0 : data.header) === null || _b === void 0 ? void 0 : _b.databaseId,
        css: (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.header) === null || _c === void 0 ? void 0 : _c.css) === null || _d === void 0 ? void 0 : _d.at(0)) === null || _e === void 0 ? void 0 : _e.href,
        css_content: (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.header) === null || _f === void 0 ? void 0 : _f.css) === null || _g === void 0 ? void 0 : _g.at(0)) === null || _h === void 0 ? void 0 : _h.content,
    };
    // console.log({loading,data, id:layout?.headerId, language})
    return React.createElement("header", { className: "ltg-app-header" }, (loading || !data) ? (React.createElement("div", { className: "ltg-app-header--loading" })) : (React.createElement(React.Fragment, null,
        (sectionData === null || sectionData === void 0 ? void 0 : sectionData.css_content) && React.createElement("style", { dangerouslySetInnerHTML: { __html: sectionData.css_content } }),
        React.createElement(Template, { sections: sectionData.sections, postId: sectionData.postId, css: sectionData.css, awaitCss: true }))));
}
